<template>
 <ion-page id="lichess-disconnect-page">
    <ion-content >
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleDisconnect">
        <p></p>
        <h2>{{ displayMessage }}</h2>
        <p></p>
      </div>
  </ion-content>
  <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                         @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup>

  import { IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { v4 as uuidv4 } from 'uuid';
  import { t } from '@/composables/translateText.js'

  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import Toolbar from '@/components/Toolbar.vue';

  import { ref, watch } from 'vue'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useGetData , getLichessData, generateErrorAlertText } from '@/composables/getData.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
  import { useStringStore } from '@/stores/stringStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  const emit = defineEmits(['next-item-click'])

  const connectionStore = useConnectionStore()
  var lichessAccessToken = connectionStore.getLichessAccessToken

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
 
  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  const stringStore = useStringStore()

  const TOOLBAR_DISCONNECT = 0
  const TOOLBAR_DONE = 1

  const toolbarDisconnectElements = [
    { index : TOOLBAR_DISCONNECT, label : t("Yes - Disconnect") ,disabled : false}
  ]

   if (whichMenu == "buttons")
    toolbarDisconnectElements.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})


  const toolbarElements = ref(toolbarDisconnectElements)
  const toolbarTrigger = ref(0)

  const displayMessage = ref(t("Disconnect From Lichess?"))

  const styleDisconnect = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    menuTrigger.value++
    updateWidthHeights()
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    menuTrigger.value++
    updateWidthHeights()
  })

  function updateStyleObjects(boundaries) {
    styleDisconnect.value.height = boundaries['disconnect'].height + "px"
    styleDisconnect.value.width = boundaries['disconnect'].width + "px"
    styleDisconnect.value.top = boundaries['disconnect'].top + "px"
    styleDisconnect.value.left = boundaries['disconnect'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const disconnectPositionTop = 0
    const disconnectPositionLeft = availableSpace.leftRightIndent
    const disconnectHeight = availableSpace.height - disconnectPositionTop
    const disconnectWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { disconnect : {
        width : disconnectWidth,
        height : disconnectHeight,
        left : disconnectPositionLeft + availableSpace.leftIndent,
        top : disconnectPositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_DONE :
        emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
        break
      case TOOLBAR_DISCONNECT :
        getDisconnect()
        break
    }
  }

  function processDisconnectJsonResponse (json) {
    //console.log(" in lichess disconnect callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    displayMessage.value = t("You have been Disconnected from Lichess.org")
    doStartupCheck(true)
    menuTrigger.value++
  }

  function getDisconnect() {
    var formData = {
    }
    useGetData("get_lichess_disconnect.php", formData, processDisconnectJsonResponse)
  }

</script>

<style scoped>

#disconnect-selector-container {
  position : relative;
  border-style : solid;
  border-width: 2px;
  margin : 0px auto;
  padding : 15px 15px;
  line-height: 1.4em;
  width : 600px;
  height: calc(100vh - 125px);
  overflow-y: auto;
  font-family: "Nunito", sans-serif;   /* rounded */
  text-align: left;

}

.reptree-move-text-light {
  color : rgb(13,110,253)
}
.reptree-move-text-dark {
  color : #fff;
}
.reptree-selected-text-light {
  color : blue;
  background : yellow;
  padding: 2px;
  border : solid 1px black;
  border-radius: 3px;
}

.reptree-selected-text-dark {
  color : #fff;
  background : gray;
  padding: 2px;
  border : solid 1px #fff;
  border-radius: 3px;
}

.repselector-center-text {
    text-align: center;
    margin-bottom : 10px;
    font-style :italic;
  }

  .repselector-heading-color {
    background: #4c6ca0;
    color : white;
  }

</style>
